










import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Button from './Button.vue'
@Component({
    components: {
        Button
    }
})
export default class RefreshButton extends Vue {
    mounted() {
       
    }

    @Emit()
    onButtonClick(){}
}
